/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Cookies from 'js-cookie';

$(document).ready(() => {
  // console.log('Hello world');
  $('.hamburger').click(function () {
    $(this).toggleClass('is-active');
    $('body').toggleClass('fix-body')
  });

  $('.blog-list').isotope({
    itemSelector: '.blog-list-post',
  });

  $('.blog-filter').on('click', 'a', function () {
    var filterValue = $(this).attr('data-filter');
    $('.blog-list').isotope({ filter: filterValue });
    $('.blog-filter a').removeClass('active');
    $(this).addClass('active');
  });










  // Grab your button (based on your posted html)
  $('.notice-cross').click(function( e ){

    // Do not perform default action when button is clicked
    e.preventDefault();

    /* If you just want the cookie for a session don't provide an expires
    Set the path as root, so the cookie will be valid across the whole site */
    $.cookie('alert-boxx', 'closed', { path: '/' });
    $('.notice-bar').animate({height:'0px'}, 500);

  });

  // Check if alert has been closed
  if( $.cookie('alert-box') === 'closed' ){

    $('.notice-bar').animate({height:'0px'}, 0);

  }
  // Check if alert has been closed
  if( !$.cookie('alert-boxx') ){

    $('.notice-bar').addClass('live');

  }




  // Select all buttons
  var buttons = document.querySelectorAll('.services-list__item-description-btn');

  // Check if there are any buttons
  if (buttons.length > 0) {
    // Function to toggle the class
    function toggleDescription() {
      console.log('i clicked');
      // The nextElementSibling of the button should be the hidden description div
      var description = this.nextElementSibling;
    
      // Toggle the 'show' class on both the button and the description div
      this.classList.toggle('show');
      description.classList.toggle('show');
    }

    // Add click event listener to each button
    buttons.forEach(function(button) {
      button.addEventListener('click', toggleDescription);
    });
  }




});
